import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  ConsultationLzzx: genStandard("consultationLzzx", "/api/ip"),
  Hospitalization: genStandard("hospitalization", "/api/ip"),
}
export default api;